export default {
    VIEW_DASHBOARD: 'view_dashboard',

    // Outlet
    VIEW_OUTLET: 'view_outlet',
    DELETE_OUTLET: 'delete_outlet',
    SAVE_OUTLET: 'save_outlet',

    // Supplier
    VIEW_SUPPLIER: 'view_supplier',
    SAVE_SUPPLIER: 'save_supplier',
    DELETE_SUPPLIER: 'delete_supplier',

    VIEW_INVENTORY: 'view_inventory',

    // Product
    VIEW_PRODUCT: 'view_product',
    SAVE_PRODUCT: 'save_product',
    DELETE_PRODUCT: 'delete_product',

    // Stock Request
    VIEW_STOCK_REQUEST: 'view_stock_request',
    SAVE_STOCK_REQUEST: 'save_stock_request',
    DELETE_STOCK_REQUEST: 'delete_stock_request',

    // Stock Check
    VIEW_STOCK_CHECK: 'view_stock_check',
    SAVE_STOCK_CHECK: 'save_stock_check',
    DELETE_STOCK_CHECK: 'delete_stock_check',

    // Stock Receive
    VIEW_STOCK_RECEIVE: 'view_stock_receive',
    SAVE_STOCK_RECEIVE: 'save_stock_receive',
    DELETE_STOCK_RECEIVE: 'delete_stock_receive',

    // Stock Return
    VIEW_STOCK_RETURN: 'view_stock_return',
    SAVE_STOCK_RETURN: 'save_stock_return',
    DELETE_STOCK_RETURN: 'delete_stock_return',

    // Stock Check
    VIEW_PURCHASE_ORDER: 'view_purchase_order',
    SAVE_PURCHASE_ORDER: 'save_purchase_order',
    DELETE_PURCHASE_ORDER: 'delete_purchase_order',

    // Audit Trail
    VIEW_AUDIT_TRAIL: 'view_audit_trail',

    // Settings
    VIEW_MEASUREMENT_UNIT: 'view_measurement_unit',
    SAVE_MEASUREMENT_UNIT: 'save_measurement_unit',
    DELETE_MEASUREMENT_UNIT: 'delete_measurement_unit',

    VIEW_TAG: 'view_tag',
    SAVE_TAG: 'save_tag',
    DELETE_TAG: 'delete_tag',

    VIEW_INTEGRATION: 'view_integration',
    SAVE_INTEGRATION: 'save_integration',

    // User management
    VIEW_USER: 'view_user',
    SAVE_USER: 'save_user',
    DELETE_USER: 'delete_user',

    // Roles
    VIEW_ROLES: 'view_roles',
    SAVE_ROLES: 'save_roles',
};



// WEBPACK FOOTER //
// ./resources/assets/js/libs/permissions.js